import { Select } from "antd";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "sonner";
import { updateEvaluation } from "../../../api/evaluations";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
//Typage des props parents
type UUID = string;
type Props = {
  show: boolean;
  metaData: any;
  evaluationID: UUID;
  onClose: () => void;
  onSaved?: () => void;
};

const MissionRepairer = ({
  metaData,
  evaluationID,
  show,
  onClose,
  onSaved,
}: Props) => {
  const [oldMissionRepairer, setOldMissionRepairer] = useState<any[]>([]);
  const [allMissionsRepairer, setAllMissionRepairer] = useState<any[]>([]);
  const [allEvaluation, setAllEvaluation] = useState<any[]>([]);
  const getModalContainer = () => {
    const modalElement = document.getElementById("modal-edit-mission-repairer");
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };

  useEffect(() => {
    if (!show || !evaluationID) return;
    // fetchEvaluationData();
    const formDataEvaluation = metaData?.all_evaluation.map(
      (evaluationItem: any) => ({
        id: evaluationItem?.id,
        value: evaluationItem?.id,
        label: evaluationItem?.label,
      }),
    );

    setAllEvaluation(formDataEvaluation);

    const formattedData = (metaData?.mission_repairer || []).map(
      (missionItem: any) => {
        const evaluation = (metaData?.all_evaluation || []).find(
          (evalItem: any) =>
            evalItem.id === missionItem.mission_evaluationrepairer_id,
        );
        return {
          id: missionItem?.mission_evaluationrepairer_id,
          label: evaluation?.label || "",
          value: missionItem?.mission_evaluationrepairer_id,
        };
      },
    );

    // console.log("mission received: ", formattedData);
    setOldMissionRepairer(formattedData || []);
  }, [show, evaluationID]);

  // Fonction pour gérer la sélection des missions réparatrices

  const handleMissionChange = (selectedIds: string[]) => {
    // Synchronize selected missions with allEvaluation
    const selectedOptions = allEvaluation.filter((evaluation: any) =>
      selectedIds.includes(evaluation.id),
    );
    // console.log("final console log: ", selectedOptions);
    setAllMissionRepairer(selectedOptions);
  };

  // fonstion de soumission
  const onSubmit = async () => {
    try {
      const allNewMissionRepairer =
        oldMissionRepairer.concat(allMissionsRepairer);

      const formattedData: any[] = allNewMissionRepairer.map(
        (missionItem) => missionItem?.id,
      );
      // console.log("formatted Data: ", formattedData);

      await updateEvaluation(evaluationID, metaData?.id_level, {
        ids_evaluationRepairer: formattedData,
      });
      toast.success("Missions réparatrices bien enregistrées");
      if (onSaved) onSaved(); // On fait un reload de la liste
      onClose();
      setAllMissionRepairer([]);
    } catch (error: any) {
      // Gérer les erreurs de l'API
      // console.log(
      //   "erreur modification missions réparatrices d'une évaluation: ",
      //   error
      // );
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };
  return (
    <>
      <Modal show={show} onHide={() => onClose()}>
        <Modal.Header closeButton>Gestion missions réparatrices</Modal.Header>
        <Modal.Body>
          <div id="modal-edit-mission-repairer">
            <div className="mb-6 flex-fill">
              <label htmlFor="">Missions Réparatrices</label>
              <Select
                id="child-selector"
                mode="multiple"
                allowClear
                className="select"
                getPopupContainer={getModalContainer}
                style={{
                  maxWidth: "500px",
                  width: "100%",
                }}
                placeholder="Please select"
                // Use value as array of ids, not labels
                value={allMissionsRepairer.map((mission: any) => mission.id)}
                options={allEvaluation.filter(
                  (evaluation: any) =>
                    evaluation.id !== evaluationID &&
                    !oldMissionRepairer.some(
                      (mission: any) => mission.id === evaluation.id,
                    ),
                )}
                onChange={handleMissionChange}
                // Show label in selected items
                optionLabelProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
              <div className="mt-3">
                {allMissionsRepairer.length === 0 &&
                oldMissionRepairer.length === 0 ? (
                  <div>Aucune mission réparatrice sélectionnée.</div>
                ) : (
                  <ul className="list-group">
                    {allMissionsRepairer.map((mission: any) => (
                      <li
                        key={mission.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>{mission.label}</span>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => {
                            setAllMissionRepairer((prev) =>
                              prev.filter((m: any) => m.id !== mission.id),
                            );
                          }}
                        >
                          Supprimer
                        </button>
                      </li>
                    ))}
                    {oldMissionRepairer.map((mission: any) => (
                      <li
                        key={mission.id}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        <span>{mission.label}</span>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => {
                            setOldMissionRepairer((prev) =>
                              prev.filter((m: any) => m.id !== mission.id),
                            );
                          }}
                        >
                          Supprimer
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* Boutton d'ajout des missions réparatrices */}
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-4">
            {/* <TooltipOption/> */}
            <div className="mb-2">
              <button
                onClick={() => {
                  setAllMissionRepairer([]);
                  onClose();
                }}
                //   to="#"
                className="btn btn-light  d-flex align-items-center"
              >
                Annuler
              </button>
            </div>

            <div className="mb-2">
              <button
                onClick={onSubmit}
                //   to="#"
                className="btn btn-primary d-flex align-items-center"
                // disabled={!selectedYear?.statut}
              >
                Enregister
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  MissionRepairer,
  [buildPermission(Resource.EVALUATION, Action.UPDATE)],
  "masquer",
);
